"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const context_1 = require("src/context/context");
const TranslationProvider_1 = require("src/providers/TranslationProvider");
const AddEditForm_1 = tslib_1.__importDefault(require("./forms/unitOrPositionForms/AddEditForm"));
const AttachDetachUserForm_1 = tslib_1.__importDefault(require("../views/forms/AttachDetachUserForm"));
const Branches_1 = tslib_1.__importDefault(require("./Branches"));
const CreateAuthority_1 = tslib_1.__importDefault(require("src/modules/references/structuralUnitsUpgraded/views/forms/CreateAuthority"));
const StructuralHierarchy_1 = tslib_1.__importDefault(require("src/modules/references/structuralUnitsUpgraded/views/StructuralHierarchy"));
const UpdateAuthority_1 = tslib_1.__importDefault(require("src/modules/references/structuralUnitsUpgraded/views/forms/UpdateAuthority"));
const StructuralTree = ({ hook, setValue, restrictOccupiedPosition, noPositionsAllowed, noStructuralUnitsAllowed }) => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    const isFirstLoad = (0, react_1.useRef)(true);
    const [attachUser, setAttachUser] = (0, react_1.useState)(null);
    const [authority, setAuthority] = (0, react_1.useState)(null);
    const [authorityId, setAuthorityId] = (0, react_1.useState)(null);
    const [editFormData, setEditFormData] = (0, react_1.useState)(null);
    const [fetchingHierarchy, setFetchingHierarchy] = (0, react_1.useState)(null);
    const [ancestors, setAncestors] = (0, react_1.useState)(null);
    const [unitAndParentId, setUnitAndParentId] = (0, react_1.useState)(null);
    const { toast } = (0, context_1.useToastContext)();
    (0, react_1.useEffect)(() => {
        const abortController = new AbortController();
        if (isFirstLoad.current && hook.state.data.length > 0) {
            openParent(hook.state.data[0]);
            isFirstLoad.current = false;
        }
        return () => abortController.abort();
    }, [hook.state.data]);
    const openParent = (parent) => {
        if (parent.hasChildren) {
            hook.getChildren(parent.id, !!parent.children.length, parent.identifier).then();
        }
    };
    const closeParent = (parentStructuralUnit) => {
        hook.closeStructuralUnit(parentStructuralUnit.identifier);
    };
    const closeAttachDetachForm = (isUpdated) => {
        setAttachUser(null);
        if (attachUser && isUpdated)
            hook.reFetchParent(attachUser.id, attachUser.parentId).then();
    };
    const closeAddEditForm = (isUpdated) => {
        setEditFormData(null);
        if (editFormData && isUpdated)
            hook.reFetchParent(editFormData.structuralUnitId, editFormData.parent?.id || '0').then();
    };
    const handleOpenHierarchy = async (item) => {
        setFetchingHierarchy(item.identifier);
        const response = await hook.getAncestors(item.id);
        setFetchingHierarchy(null);
        if (!response.errors) {
            response.data && setAncestors({ data: response.data, item });
        }
        else {
            response.errors.forEach(el => toast.danger(el.message));
        }
    };
    if (hook.state.data.length === 0) {
        return (0, jsx_runtime_1.jsx)("div", { children: translate('no_data_found', 'მონაცემები არ მოიძებნა') });
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'tree-demo jstree jstree-4 jstree-default', children: [(0, jsx_runtime_1.jsx)("ul", { className: 'jstree-container-ul jstree-children jstree-contextmenu', children: (0, jsx_runtime_1.jsx)(Branches_1.default, { hook: hook, openParent: openParent, closeParent: closeParent, structuralUnits: hook.state.data, setAttachUser: setAttachUser, setAuthority: setAuthority, setUnitAndParentId: setUnitAndParentId, setAuthorityId: setAuthorityId, setEditFormData: setEditFormData, handleOpenHierarchy: handleOpenHierarchy, fetchingHierarchy: fetchingHierarchy, setValue: setValue, restrictOccupiedPosition: restrictOccupiedPosition, noPositionsAllowed: noPositionsAllowed, noStructuralUnitsAllowed: noStructuralUnitsAllowed }) }), attachUser
                ? (0, jsx_runtime_1.jsx)(AttachDetachUserForm_1.default, { contractId: attachUser.contractId, structuralUnitId: attachUser.id, closeAttachDetachForm: closeAttachDetachForm })
                : null, editFormData
                ? (0, jsx_runtime_1.jsx)(AddEditForm_1.default, { formCategory: editFormData.formCategory, parent: editFormData.parent, structuralUnitId: editFormData.structuralUnitId, closeForm: closeAddEditForm })
                : null, authority ?
                (0, jsx_runtime_1.jsx)(CreateAuthority_1.default, { setAuthority: setAuthority, unitAndParentId: unitAndParentId, authority: authority, reFetchParent: hook.reFetchParent })
                : null, authorityId ?
                (0, jsx_runtime_1.jsx)(UpdateAuthority_1.default, { reFetchParent: hook.reFetchParent, unitAndParentId: unitAndParentId, setAuthorityId: setAuthorityId, authorityId: authorityId })
                : null, ancestors?.data ? ((0, jsx_runtime_1.jsx)(StructuralHierarchy_1.default, { closeForm: () => setAncestors(null), ancestors: ancestors })) : null] }));
};
exports.default = StructuralTree;
